import { useEffect, useState } from "react";

import { COMPARE_COST_INVALIDATE } from "@penn/web-common";
import {
  WORK_FOR_STORAGE_KEY,
  readStoredWorkFor,
  type StoredWorkFor,
} from "@penn/web-common";

// Reactive view of the current Work-For context. The selector persists changes
// to session storage and fires COMPARE_COST_INVALIDATE; we re-read on that (same
// tab) and on `storage` (other tabs) so the banner/padding stay in sync.
export function useWorkFor(): StoredWorkFor {
  const [stored, setStored] = useState<StoredWorkFor>(() => readStoredWorkFor());

  useEffect(() => {
    const sync = () => setStored(readStoredWorkFor());
    const onStorage = (e: StorageEvent) => {
      if (e.key === null || e.key === WORK_FOR_STORAGE_KEY) sync();
    };
    window.addEventListener(COMPARE_COST_INVALIDATE, sync);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(COMPARE_COST_INVALIDATE, sync);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return stored;
}
